export const environment = {
    production: true,
    app: 'innovateBackendApp-Prod',
    innovate: {
        url: 'https://edgeapi.innovatemr.net', // https://api.pegasusmr.com
        maskedUrl: 'https://survey.answerplatform.com',
        FEMaskedURL: 'https://surveys.answerplatform.com',
        newBEHost: 'https://surveyflow-api.innovatemr.net',
        version: 'v1',
        surveyClosedMessages: {
            0: { 'h1': 'Survey Unavailable', 'h4': 'Sorry, this survey is currently not available.' }, //normal
            1: { 'h1': 'Thank you for trying this survey.', 'h4': 'We’re sorry, but you were not able to complete that survey. Sometimes the survey is looking for a particular demographic or specific types of interests, and you may not have fit what they were looking for..' }, // disqualify
            2: { 'h1': 'Survey Unavailable', 'h4': 'Sorry, this survey already taken by you.' },
            3: { 'h1': 'Survey Unavailable', 'h4': 'mis match of query string data from saved data.' },
            4: { 'h1': 'Survey Unavailable', 'h4': 'Sorry, transaction id not exist in query string.' },
            5: { 'h1': 'Thank you for trying this survey.', 'h4': 'We’re sorry, but you were not able to complete that survey. When a survey has filled in the number of respondents who fit the goal, it will be closed' } // quota full
        },
        zipcodesQuesId: 3,
        masterZipAnsKeyObj: {
            DMA_CODE: 'dma',
            DMA_NAME: 'dmaName',
            REGION: 'rgn',
            STATE: 'stName',
            ZIPCODES: 'id'
        },
        // recaptchaSiteKey: "6LdQiqcUAAAAAPCZWsNSmq1kXQD6y9zWBsbDQ5im", // for Pegasus 6Lc7Aj8UAAAAALoiKc07BG4l6NgnpAH5zZARmaPF
        inboxSupId: 147,
        pointClubSupId: '78',
        BIHSupId: '816',
        numZipCodeSupportedCnt: {//support Numeric Zipcode only
            0: "US",
            1: "IN"
        },
        GA_TRACKING_ID: "UA-47211927-4",//google Analytics
        cntShortCode: {
            "US": "United States"
            //"GB": "United Kingdom",
            //"CA": "Canada"
        },
        zipCntShortCode: { // ADMIN-5113
            "GB": "United Kingdom",
            "CA": "Canada"
        },
        recaptchaDisabledOnGrpId: [526494, 528709],
        // enableRecaptcha: true, // false means recaptcha is disabled
        enableOEVaildation: true,        // false means it will check for oe validation
        piiOptQuesId: 8458,
        piiCategoryId: 207,
        smsCategoryId: 232,
        questionType: {
            'numericOpenEnded': 'Numeric Open Ended',
            'openEndedText': 'Open End-Text'
        },

        redHerringQuestionId: 4,
        dobRedHerringQId: 8608,
        dobRedHerringQueskey: "DOB",
        "qualitativeQuesCatId": 208,
        dynamicProGPTCatId: 244,
        transactionStatus: {
            "OQ": 3,
            "QT": 4,
            "PST": 5,
            "SSDNC": 6,
            "PSOQ": 7,
            "PSQT": 8,
        },
        geoQuestionKeys: ["DMA_NAME", "REGION", "STATE", "ZIPCODES"],
        trimsterQuestionsAdded: ['PARENTING_12859', 'PARENTING_12860'],
        trimsterQueKey: "PARENTING_12859",
        babyCenterQueCatId: 214,
        babyCenterProfileSurveyJobId: 5571421,
        wteProfileSurveyJobId: 5654229,
        bbCenterExpectedDueDateQueId: 12792,
        bbCenterChildInfoQueId: 12796,
        skipQuestionsOn: {
            'BABY_CENTER_12785': { skipOnValue: 'yes', skipKeys: ['BABY_CENTER_12786', 'BABY_CENTER_12793'] },
            'BABY_CENTER_12786': { skipOnValue: 'yes', skipKeys: ['BABY_CENTER_12793', 'BABY_CENTER_12792'] },
            'BABY_CENTER_12793': { skipKeys: ['BABY_CENTER_12792'] },
            'BABY_CENTER_12795': { skipOnValue: '0', skipKeys: ['BABY_CENTER_12796', 'BABY_CENTER_12797'], addChildInfo: true }
        },
        profilingJobs: [5654229, 6238923],
        DISABLE_FINGERPRINTING: false,
        trimsterWeeks: [
            { "min": 0, "max": 13, "trimster": 1, "week": 1 },
            { "min": 13.01, "max": 26, "trimster": 2, "week": 1 },
            { "min": 26.01, "max": 40, "trimster": 3, "week": 1 },
            { "min": 41.01, "trimster": 4, "week": 2 }
        ],
        babyCenterChildQueAdded: ['BABY_CENTER_12795', 'BABY_CENTER_12796'],
        ageOfChildrenQueId: 6796,
        babyCenterChildCountQueId: 12795,
        ageOfChildrenQueKey: "DEMOGRAPHIC_6796",
        teenAge: 13,
        babyCenterChildCountQueKey: "BABY_CENTER_12795",
        smsVerificationRetries: 3,
        triggerNewSupplierURL : true,
        researchDefender:{
            getTokenAPI : 'https://prod.rtymgt.com/api/v3/respondents/get_token/a7b5f743-279f-485e-96b9-dea2fdc79a44?tokens=1',
            activityURL : 'https://prod.resdefio.com/activity?range=24&panel_id=',
            headerValue: 'auQpVd4NBn97YvXTvdapSaHuF1yLvB3t8l1WTBfu',
            xhrFields: {
              'Access-Control-Allow-Methods' : 'GET, POST',
              'Access-Control-Allow-Headers' : "Access-Control-Allow-Headers, Origin, X-Requested-With, Content-Type, Accept, Authorization",
              'Access-Control-Allow-Credentials' : true,
            },
            activityTimeout: 8000,
            getTokenTimeout: 8000
        },
        IPQS_URL: 'https://www.ipqscloud.com/api/innovatemr.net/s7gdruv9EThPtAv35m2aH5o8fqK1wImfMh1YZ46Kmlrl1GKebGMQwLjyQwXUOeaVWTFExpZe1L7iVgJrm3j8CUlFKvge6eq0EmkC6xpxO7rPrx72iilRiUoxWwXggXyt7Sv2VLBcYP6SSYYWrHybAVvM4lKyLm0uwAa2WTDDoxdoC7eNxqs3H31YWG4OTCJH5hTIxUrTZEefEq3W5hXhTpUpEn2momuzEQZYvsI0bLMu4CLs7YByrzMcEVxEUZPV/learn.js',
        IPQS_image: 'https://www.ipqscloud.com/api/innovatemr.net/s7gdruv9EThPtAv35m2aH5o8fqK1wImfMh1YZ46Kmlrl1GKebGMQwLjyQwXUOeaVWTFExpZe1L7iVgJrm3j8CUlFKvge6eq0EmkC6xpxO7rPrx72iilRiUoxWwXggXyt7Sv2VLBcYP6SSYYWrHybAVvM4lKyLm0uwAa2WTDDoxdoC7eNxqs3H31YWG4OTCJH5hTIxUrTZEefEq3W5hXhTpUpEn2momuzEQZYvsI0bLMu4CLs7YByrzMcEVxEUZPV/pixel.png',
        CLEAN_ID_DATA_KEY: 'ECA56E6ED6A1B60942434DD31E11A1AB-30004-1',
        secretKeyToEncDcryPayload: 'innovateProduction',
        chatGPTEnabledJobIds: [10358980, 10407239],
        oldRouteEnable: false,
        supRecnctCodeArr: ['QMEEAPI', 'PRMAPI', 'trapi', 'ergapi', 'CPXAPI', 'IconicAPI', 'GRLAPI'], // For ComScore tagging
        midTaggingForComscore: false,
        googleAddressVerificationEnabled: true,
        allowedJobIds: ['1410469', '1440907', '12039958', '12072807', '12074605', '12089574', '12121423', '12125825', '12127612', '12130617', '12130667', '12132265', '12132335', '12133859', '12133873', '12133913', '12134039', '12136804', '12138643', '12139837', '12143780', '12144842', '12145103', '12157463', '12162705', '12164904', '12173055', '12224452', '12255552', '12260371', '12260675', '12265514', '11819109', '12103240', '12164574', '12174616', '12191033', '12205409', '12226342', '12230616', '12231668', '12231760', '12233011', '12248022', '12248101', '12248571', '12249575', '12250327', '12256149', '12256153', '12261636', '12266662', '12282171', '12218889', '12103356', '12259681', '11694803', '11844629', '11933563', '12040026', '12128485', '12091935', '12097674', '12097713', '12120501', '12121562', '12121770', '12136250', '12285051', '12285045'], // 12285051,12285045
        FINGERPRINT_URL: "https://edgesurvey-fing.innovatemr.net",
        DFIQ_S2S_API_ENABLED : true,
        VERISOUL_PROJECT_ID: "7969777b-bc72-473c-84d2-5081bbd85ed6",
        googleAddressEnableCust: 422,
        allFingerPrintingJobIds: [12746200, 12746200, 12742356, 12724963, 12789061, 12803117, 12841282, 12517153, 12602549],
        veriSoulEnv: 'prod',
        rdUrl : 'https://prod.rtymgt.com/static/js/rd_sys_util.min.js',
        cleanIdIframe : true,
        zipCntShortCodeArr: ['GB', 'CA'],
        srvySatOtherOptId: '5',
        supCodeListForVeritonicPixel: [78, 816, 615, 670, 477, 989, 269, 1018, 595, 642, 1133, 292, 1086, 1105, 344, 745, 774, 886, 415, 465], // For Veritonic pixel
        VERISOUL_CUSTOM_DOMAIN : 'verfing.innovatemr.net',
        VERISOUL_API_TIMEOUT: 10000,
        DFIQ_API_TIMEOUT: 12000,
        ROUNDTABLE_SCRIPT_ID: 'roundtable-rt-js',
        ROUNDTABLE_SCRIPT_SRC: 'https://cdn.roundtable.ai/v1/rt.js',
        ROUNDTABLE_SITE_KEY: 'pub-IFtyTZmsbg5eBXLIJUFn',
        VERISOUL_HK: 'sha256-djmJ48CjCfXomE4x2us2ah26HMfPp94fry65gUtGBSY=',
        VERISOUL_DYNAMIC_SCRIPT_ENABLED: true,
        digitalFingerPrint: {
            'No Fingerprinting': 0,
            'Relevant Id': 1,
            'True Sampling': 2,
            'Research Defender': 3,
            'Clean ID': 4,
            'Verisoul': 5
        }
    }
};
